import { Component, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-tabela-dinamica-dialog',
  templateUrl: './tabela-dinamica-dialog.component.html',
  styleUrls: ['./tabela-dinamica-dialog.component.css']
})
export class TabelaDinamicaDialogComponent {
  colunasSelecionadas: any[] = [];
  subtabelasDisponiveis: any[] = [];
  subtabelasSelecionadas: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<TabelaDinamicaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ngZone: NgZone
  ) {
    // Converte objeto em array e adiciona "ativa: true"
    const colunasObject = data.tabela.colunas; // agora é um objeto com várias propriedades
    this.colunasSelecionadas = Object.keys(colunasObject)
    .filter(chave => colunasObject[chave]?.placeholder) // só inclui se tiver Placeholder
    .map(chave => ({
      ...colunasObject[chave],
      ativa: true
    }));

    // Carrega subtabelas disponíveis, se existirem
    this.carregarSubtabelas();
  }

  carregarSubtabelas() {
    const subtabelasObject = this.data.tabela.subtabelas;
    if (!subtabelasObject) {
      this.subtabelasDisponiveis = [];
      return;
    }

    this.subtabelasDisponiveis = Object.keys(subtabelasObject)
      .filter(chave => subtabelasObject[chave]?.informacoesTabela)
      .map(chave => {
        const subtabela = subtabelasObject[chave];
        const colunasObj = subtabela.colunas || {};
        const colunas = Object.keys(colunasObj)
          .filter(colKey => colunasObj[colKey]?.placeholder)
          .map(colKey => ({
            ...colunasObj[colKey],
            ativa: true
          }));

        return {
          chave: chave,
          nome: subtabela.informacoesTabela.nome,
          placeholder: subtabela.informacoesTabela.placeholder,
          colunas: colunas,
          ativa: false
        };
      });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.colunasSelecionadas, event.previousIndex, event.currentIndex);
  }

  dropSubtabelaColuna(event: CdkDragDrop<string[]>, subtabela: any) {
    moveItemInArray(subtabela.colunas, event.previousIndex, event.currentIndex);
  }

  gerarTabela() {
    const subtabelasAtivas = this.subtabelasDisponiveis.filter(s => s.ativa);
    const html = this.gerarHtmlTabela(this.colunasSelecionadas, this.data.tabela.informacoesTabela.placeholder, subtabelasAtivas);
    this.resetarColunas();

    this.ngZone.run(() => {
      this.dialogRef.close(html);
    });

  }

  resetarColunas() {
    this.colunasSelecionadas = [];
    this.subtabelasDisponiveis = [];
  }

  gerarHtmlTabela(colunas: any[], placeholder: string, subtabelasAtivas: any[]): string {
    const colunasVisiveis = colunas.filter(c => c.ativa);
  
    // Aplica borda em todas as células <th>
    const thead = colunasVisiveis
      .map(c => `<th style="border: 1px solid #ecf0f1; padding: 14px;text-align: left; font-size: 10pt; white-space: nowrap;">${c.nome}</th>`)
      .join('');
  
    const placeholders = colunasVisiveis.map(c => c.placeholder).join(',');
    const placeholderFinal = `{{${placeholder.replace('{{', '').replace('}}', '')}:${placeholders}}}`;

    // Gera HTML das subtabelas ativas no estilo visual da fatura-cadastro
    let subtabelasHtml = '';
    if (subtabelasAtivas && subtabelasAtivas.length > 0) {
      subtabelasAtivas.forEach(subtabela => {
        const subColunasVisiveis = subtabela.colunas.filter(c => c.ativa);
        if (subColunasVisiveis.length > 0) {
          const subThead = subColunasVisiveis
            .map(c => `<th style="padding: 6px 10px; text-align: left; border-bottom: 1px solid #ddd; font-size: 13px; font-weight: 600;">${c.nome}</th>`)
            .join('');

          const subPlaceholders = subColunasVisiveis.map(c => c.placeholder).join(',');
          const subPlaceholderFinal = `{{${subtabela.placeholder.replace('{{', '').replace('}}', '')}:${subPlaceholders}}}`;

          subtabelasHtml += `
            <tr>
              <td colspan="${colunasVisiveis.length}" style="padding: 0; border: none;background-color: #f9f9f9" data-subtabela-dinamica="${subtabela.placeholder}" >
                <div style="padding: 30px 30px;">
                  <p style="font-size: 10pt; color: #282d36; margin: 0 0 12px 0; display: flex; align-items: center; gap: 4px; font-weight: 600;">+ ${subtabela.nome}</p>
                  <table style="width: 100%; border-collapse: collapse; font-size: 13px;">
                    <thead>
                      <tr>${subThead}</tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colspan="${subColunasVisiveis.length}" style="padding: 6px 10px; border-bottom: 1px solid #eee; text-align: left;" data-subtabela-dinamica-conteudo="${subtabela.placeholder}">
                          <div style="color:red; font-weight:600">⚠️ NÃO REMOVER OS CÓDIGOS ABAIXO (caso remova sua subtabela não funcionará)</div>
                          ${subPlaceholderFinal}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>`;
        }
      });
    }
  
    return `
      <table style=" width: 100%;
        max-width: 100%;
        border-collapse: collapse; border: 1px solid #ecf0f1;">
        <thead style="background-color: #ecf0f1;">
          <tr>${thead}</tr>
        </thead>
        <tbody>
          <tr style="border: 1px solid #ecf0f1;">
            <td colspan="${colunasVisiveis.length}" style="padding: 8px;text-align: left; font-size:10pt" data-tabela-dinamica="${placeholder}">
              <div style="color:red; font-weight:600">⚠️ NÃO REMOVER OS CÓDIGOS ABAIXO (caso remova sua tabela não funcionará)</div> 
              ${placeholderFinal}
            </td>
          </tr>${subtabelasHtml}
        </tbody>
      </table>
    `;
  }
  

  cancelar() {
    this.resetarColunas();

    this.ngZone.run(() => {
      this.dialogRef.close();
    });

  }
}
